module.exports = __webpack_public_path__ + "static/media/forward-button.5dfce3bd.svg";